import { ReflectUtils } from "@dooboostore/core";
import { ElementApply } from "@dooboostore/core-web";
import { SwcUtils } from "../utils/Utils.js";
const STATE_METADATA_KEY = Symbol.for("simple-web-component:state");
function state(nameOrTarget, propertyKey) {
  const stateDefine = (targetObj, stateMetadata) => {
    const storageKey = Symbol(`state:${String(stateMetadata.propertyKey)}`);
    Object.defineProperty(targetObj, stateMetadata.propertyKey, {
      set(nv) {
        this[storageKey] = nv;
        const ea = new ElementApply(this, { id: this._swcId });
        const helperHostSet = SwcUtils.getHelperAndHostSet(this);
        const stateContext = { ...helperHostSet };
        findAllStateMetadata(this).forEach((it) => {
          stateContext[it.name] = this[it.propertyKey];
        });
        ea.apply({ context: stateContext, targetVariableName: stateMetadata.name, bind: this });
      },
      get() {
        const own = Object.getOwnPropertyDescriptor(this, stateMetadata.propertyKey);
        if (own && "value" in own) {
          delete this[stateMetadata.propertyKey];
          this[storageKey] = own.value;
        }
        return this[storageKey];
      },
      enumerable: true,
      configurable: true
    });
  };
  if (typeof nameOrTarget === "object" && propertyKey) {
    const targetObj = nameOrTarget;
    const name = String(propertyKey);
    const constructor = targetObj.constructor;
    let states = ReflectUtils.getOwnMetadata(STATE_METADATA_KEY, constructor);
    if (!states) {
      states = [];
      ReflectUtils.defineMetadata(STATE_METADATA_KEY, states, constructor);
    }
    const stateMetadata = { propertyKey, name };
    states.push(stateMetadata);
    stateDefine(targetObj, stateMetadata);
    return;
  }
  return (targetObj, propertyKey2) => {
    const name = String(nameOrTarget);
    const constructor = targetObj.constructor;
    let states = ReflectUtils.getOwnMetadata(STATE_METADATA_KEY, constructor);
    if (!states) {
      states = [];
      ReflectUtils.defineMetadata(STATE_METADATA_KEY, states, constructor);
    }
    const stateMetadata = { propertyKey: propertyKey2, name };
    states.push(stateMetadata);
    stateDefine(targetObj, stateMetadata);
  };
}
const findAllStateMetadata = (target) => {
  const constructor = typeof target === "function" ? target : target.constructor;
  return ReflectUtils.findAllMetadata(STATE_METADATA_KEY, constructor).flat();
};
export {
  STATE_METADATA_KEY,
  findAllStateMetadata,
  state
};
//# sourceMappingURL=state.js.map
